import styled, { css } from 'styled-components';
import { crTheme, Text } from '@comicrelief/component-library';
import { JourneySelectLabelProps } from './types';

const JourneySelectRadioButton = styled.input`
    // Hiding the button itself, letting us purely use
    // the wrapping label as the 'button'
    display: none;
`;

const JourneySelectWrapper = styled.div`
    width: 100%;
    padding: 4px;
    position: relative;
    display: flex;
    flex-direction: column;
    margin: 0;
    border-radius: 3.5rem;

    @media ${crTheme.allBreakpoints('M')} {
        flex-direction: row;
        height: 68px;
        background: ${crTheme.color('blue_light')};
        margin-bottom: 40px;
    }
`;

const JourneySelectLabel = styled.label<JourneySelectLabelProps>`
    display: flex;
    align-items: center;
    flex-grow: 1;
    flex-basis: 0;
    padding: 18px 30px;
    font-size: 14px;
    line-height: 17px;
    text-align: center;
    font-weight: bold;
    background: ${crTheme.color('blue_light')};
    color: ${crTheme.color('black')};
    border-radius: 3.5rem;
    transition: background-color linear 0.2s, color linear 0.2s;
    flex-direction: column;
    margin-bottom: 20px;
    justify-content: center;

    &:hover {
        // TO-DO: suss out filters
        background-color: #d5dfff;
    }

    ${({ selected }) => (selected && css`
        background-color: ${crTheme.color('blue_donate')};
        color: ${crTheme.color('white')};

        &:hover {
            background-color: #011a85;
        }
    `)};

    @media ${crTheme.allBreakpoints('M')} {
        flex-direction: row;
        margin-bottom: 0;
        padding: 0 30px;
    }
`;

const HeaderImage = styled.img`
  display: block;
  width: calc(100% + 50px);
  margin: -25px -25px 25px;
    @media ${crTheme.allBreakpoints('M')} {
        width: calc(100% + 80px);
        margin: -40px -40px 40px;
    }
`;

const ChooseAmountText = styled(Text)`
  margin-bottom: 1.5rem;
`;

const IntroCopyWrapper  = styled.div`
    margin: 1rem 0 2rem;
`;

const FundraisingDecimalHintWrapper = styled.div`
  margin-top: 2rem;
`;

const Subtitle = styled(Text)<{ $hasIntroCopy: boolean }>`
    margin-bottom: ${({ $hasIntroCopy }) => ($hasIntroCopy ? '1rem' : '2rem')};
`;

export {
  JourneySelectWrapper, JourneySelectRadioButton, JourneySelectLabel, HeaderImage, ChooseAmountText, IntroCopyWrapper, Subtitle, FundraisingDecimalHintWrapper
};
